import { Button, Dropdown, Flex, Table, Tag } from "antd";
import React, { useEffect, useState } from "react";
import CustomHeader from "../../components/header/CustomHeader";
import api from "../../api";
import { useToast } from "../../components/toast/toast";
import { IconEdit, IconPlus, IconTrash } from "@tabler/icons-react";
import CustomModal from "../../components/modal/CustomModal";
import CustomInput from "../../components/input/CustomInput";
import CustomSelect from "../../components/select/CustomSelect";
import { validateEmail } from "../../utilities/utils";
import ConfirmModal from "../../components/modal/ConfirmModal";

const Staff = () => {
  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [selected, setSelected] = useState(null);
  const [name, setName] = useState("");
  const [mail, setMail] = useState("");
  const [role, setRole] = useState("");

  const toast = useToast();

  const fetchList = async () => {
    setIsLoading(true);
    const res = await api.get_user_list();
    // console.log("user res --->", res);

    if (res.status === 200) {
      setList(res.data.data);
    } else {
      toast(res.data?.message || "Алдаа гарлаа", "error");
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchList();
  }, []);

  const submitHandler = async () => {
    const res = await api.create_user({
      name,
      role,
      gmail: mail,
    });
    // console.log("create user -->", res);
    if (res.status === 201) {
      toast("Амжилттай", "success");
      clearHandler();
      fetchList();
    } else {
      toast(res.data?.message || "Алдаа гарлаа", "error");
    }
  };

  const deleteHandler = async () => {
    // const res = await api.delete_user(selected);
    // console.log("delete_user res --->", res);
    // if (res.status === 200) {
    //   toast("Амжилттай устгалаа", "success");
    //   setSelected(null);
    //   fetchList();
    // } else {
    //   toast(res.data?.message || "Алдаа гарлаа", "error");
    // }
  };

  const columns = [
    {
      title: "Ажилтан",
      key: "staff",
      render: (_, record) => {
        const name = record.UserProfile?.name || "-";
        const email =
          record.UserPrimaries.find((p) => p.type === "email")?.primary || "-";

        return (
          <div>
            <h4 style={{ fontWeight: 600 }}>{name}</h4>
            <p style={{ fontSize: 12, color: "#888" }}>{email}</p>
          </div>
        );
      },
    },
    {
      title: "Төлөв",
      key: "role",
      render: (_, record) => {
        const data = record.UserPrimaries.find((p) => p.type === "email");
        if (data?.is_verified) return <Tag color="green">Баталгаажсан</Tag>;
        if (data?.is_verified === false)
          return <Tag color="red">Баталгаажаагүй</Tag>;
        return "-";
      },
    },
    {
      title: "Эрх",
      key: "role",
      render: (_, record) => record.Role?.name || "-",
    },
    {
      title: "Үйлдэл",
      key: "action",
      width: 150,
      render: (_, record) => {
        const items = [
          {
            key: "edit",
            label: "Засах",
            icon: <IconEdit size={14} />,
          },
          {
            key: "delete",
            label: "Устгах",
            icon: <IconTrash size={14} />,
          },
        ];

        return (
          <Dropdown
            menu={{
              items,
              onClick: ({ key }) => {
                if (key === "edit") {
                  // setVisible(true);
                  console.log("edit");
                } else if (key === "delete") {
                  // console.log("Устгах:", record.id);
                  // setIsDeleteModal(true);
                  console.log("delete");
                }
                // setSelected(record.id);
              },
            }}
            trigger={["hover"]}
          >
            <Button type="text" icon={<IconEdit size={18} />} />
          </Dropdown>
        );
      },
    },
  ];

  const clearHandler = () => {
    setName("");
    setMail("");
    setRole("");
    setShowModal(false);
  };

  return (
    <Flex vertical>
      <CustomHeader
        title={"Ажилчидын жагсаалт"}
        rightSide={
          <Button
            type="primary"
            style={{ padding: "0 30px" }}
            onClick={() => setShowModal(true)}
          >
            <IconPlus size={16} /> Ажилтан нэмэх
          </Button>
        }
      />

      <Table
        columns={columns}
        rowKey="id"
        dataSource={list}
        loading={isLoading}
      />

      <CustomModal
        title={"Ажилтан нэмэх"}
        open={showModal}
        onCancel={clearHandler}
        disabled={!(validateEmail(mail) && name && role)}
        onOk={submitHandler}
      >
        <Flex vertical gap={"10px"}>
          <CustomInput
            title={"Нэр"}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <CustomInput
            title={"Имэйл"}
            value={mail}
            onChange={(e) => setMail(e.target.value)}
          />
          <CustomSelect
            title={"Эрх"}
            value={role}
            onChange={(e) => setRole(e)}
            options={[
              { label: "Админ", value: "admin" },
              { label: "Эдитор", value: "editor" },
              { label: "Оператор", value: "operator" },
              // { label: "Дуудлагын ажилтан", value: "call_agent" },
            ]}
          />
          <Flex
            style={{
              padding: "10px",
              border: "1px solid #FA8C16",
              borderRadius: "4px",
              backgroundColor: "#ffefde",
            }}
          >
            <p style={{ textAlign: "justify" }}>
              Хэрэглэгчийн нууц үг "
              <span style={{ color: "#0066cc", fontWeight: 600 }}>pass123</span>
              " гэж үүсгэгдэнэ. Хэрэглэгч бүртгүүлсний дараа өөрийн нууц үгийг
              аюулгүй байдлын үүднээс заавал солих шаардлагатай.
            </p>
          </Flex>
        </Flex>
      </CustomModal>

      <ConfirmModal
        variant="warning"
        showModal={isDeleteModal}
        setShowModal={setIsDeleteModal}
        cancelHandler={() => {
          setSelected(null);
        }}
        submitHandler={deleteHandler}
        title="Итгэлтэй байна уу?"
        description={
          <>
            '
            <span style={{ fontWeight: 600, color: "#0066cc" }}>
              Хэрэглэгч устгах
            </span>
            ' үйлдэл нь буцаах боломжгүйг анхаарна уу!
          </>
        }
      />
    </Flex>
  );
};

export default Staff;
